import { Middleware } from "../middleware"
export default{
    managementChannelLoki(){
        return new Middleware()
        .method('GET')
        .append('/loki/channel/all')
        .build()
    },
    typesChannelsLoki(){
        return new Middleware()
        .method('GET')
        .append('/loki/channel/msgType')
        .build()
    },
    addChannelLoki(data){
        return new Middleware()
        .method('POST')
        .append('/loki/channel/add')
        .setData(data)
        .build()
    },
    addMessageLoki(data){
        const message = data.message
        return new Middleware()
        .method('POST')
        .append('/loki/channel/add-message')
        .params({
            id: data.id
        })
        .setData(message)
        .build()
    },
  

    countMessageChannels(){
        return new Middleware()
        .method('GET')
        .append('/loki/channel/messages-count')
        .build()
    }

}